import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getJwt } from '@/shared/lib/betterAuth/get-jwt'
import { queryClient } from '@/shared/lib/tanstack'
import { CLAIMS_QUERY_KEYS } from '@/shared/constants/cache'
import { createPetClaim } from '@/services/claims.services'
import type { CreatePetClaimBody } from '@/services/claims.services'

export function useCreatePetClaim() {
  const { i18n } = useTranslation()

  return useMutation({
    mutationFn: async (body: CreatePetClaimBody) => {
      const token = await getJwt()
      if (!token) throw new Error('No JWT token')
      return createPetClaim(token, i18n.language, body)
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: CLAIMS_QUERY_KEYS.all }),
    onError: console.error,
  })
}
